// SPDX-License-Identifier: AGPL-3.0-or-later

import * as ColorUtils from '@app/features/theme/utils/ColorUtils';
import type {User} from '@app/features/user/models/User';
import {getSystemUserBrandingColor} from '@app/features/user/utils/AvatarUtils';

type RawAccentColor = number | null | undefined;

function getAccentColorHex(rawAccentColor?: RawAccentColor): string | null {
	if (rawAccentColor == null) {
		return null;
	}
	return ColorUtils.int2hex(rawAccentColor);
}

export function getUserAccentColor(
	user: User | null | undefined,
	profileAccentColor?: RawAccentColor,
	fallback = 'var(--profile-banner-background, var(--background-secondary-alt))',
): string {
	const systemColor = user ? getSystemUserBrandingColor(user.id) : null;
	if (systemColor) {
		return systemColor;
	}
	const profileColor = getAccentColorHex(profileAccentColor);
	if (profileColor) {
		return profileColor;
	}
	// Only explicit profile choices personalize a profile surface. Avatar colors
	// are derived media metadata, including old defaults, and do not color the card.
	if (profileAccentColor === undefined && user && typeof user.accentColor === 'number') {
		return ColorUtils.int2hex(user.accentColor);
	}
	return fallback;
}

export function getUserProfileBorderColor(user: User | null | undefined, profileAccentColor?: RawAccentColor): string {
	return getUserAccentColor(user, profileAccentColor, 'var(--profile-card-border, var(--border-color))');
}
